import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { shared } from '../../../../../constants/NationalAccount';

export const CancelButton = ({ handleClose, closeBlurb }: any): JSX.Element => {
  return (
    <Button variant="text" onClick={handleClose}>
      {!closeBlurb ? shared.cancel : closeBlurb}
    </Button>
  );
};

export const ConfirmButton = ({
  confirmBlurb,
  disabled,
  cb,
}: any): JSX.Element => {
  return (
    <Button variant="primary" type="submit" disabled={disabled} onClick={cb}>
      {confirmBlurb}
    </Button>
  );
};

export const ModalButtonGroup = ({
  confirmBlurb,
  cancelBlurb,
  handleClose,
  disabled,
  cb,
}: any) => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-4 sm:sui-flex-row-reverse">
      <div data-testid="confirmButtonContainer">
        <ConfirmButton
          confirmBlurb={confirmBlurb}
          disabled={disabled}
          cb={cb}
        />
      </div>
      <div data-testid="cancelButtonContainer" className="sui-text-center">
        <CancelButton handleClose={handleClose} closeBlurb={cancelBlurb} />
      </div>
    </div>
  );
};
